import React from "react";
import { useFieldArray } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";

interface HeaderProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
}

const VendorRatesSubForm: React.FC<HeaderProps> = ({
  control,
  errors,
  watch,
  setValue,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "rate_data",
  });

  // Initialize with one empty field if none exists
  React.useEffect(() => {
    if (fields.length === 0) {
      append({});
    }
  }, [fields.length, append]);

  const options_select = [
    { value: "1", label: "Fixed" },
    { value: "2", label: "Minimum" },
    { value: "3", label: "Per Unit" },
  ];

  const hsnData = [
    { value: "1", label: "Parking & Charging" },
    { value: "2", label: "Parking" },
    { value: "3", label: "Charging (AC)" },
    { value: "5", label: "Charging (DC)" },
    { value: "4", label: "Rent" },
    { value: "6", label: "Infra Sharing" },
    { value: "7", label: "Charging(Office)" },
    { value: "8", label: "Support Services" },
  ];

  const options_vehicle = [
    { value: "1", label: "2WL" },
    { value: "2", label: "3 WL" },
    { value: "3", label: "4 WL" },
    { value: "4", label: "ZEN" },
    { value: "5", label: "TATA_ACE" },
  ];

  const addRemoveButtons = (index: number): React.ReactNode => (
    <>
      <span className="icon">
        {index === fields.length - 1 && (
          <i
            className="fa fa-plus has-text-link smart-cursor"
            onClick={() => append({})}
          />
        )}
      </span>
      <span className="icon">
        {fields.length > 1 && (
          <i
            className="fa fa-trash has-text-danger smart-cursor"
            onClick={() => remove(index)}
          />
        )}
      </span>
    </>
  );

  const getElements = (index: number): SdsFormElementProps[] => {
    const data = watch(`rate_data.${index}`) || {};

    return [
      {
        type: "SELECT_BOX",
        width: 2,
        name: `rate_data.${index}.sd_hsn_id`,
        element: { options: hsnData, size: "small" },
      },
      {
        type: "SELECT_BOX",
        width: 1,
        name: `rate_data.${index}.sd_vehicle_types_id`,
        element: {
          options: options_vehicle,
          size: "small",
        },
      },
      {
        type: "SELECT_BOX",
        width: 2,
        name: `rate_data.${index}.rate_type`,
        element: { options: options_select, size: "small" },
      },
      {
        type: "TEXT_BOX",
        width: 1,
        name: `rate_data.${index}.min_start`,
        element: {
          size: "small",
        },
      },
      {
        type: "TEXT_BOX",
        width: 1,
        name: `rate_data.${index}.min_end`,
        element: {
          size: "small",
        },
      },
      {
        type: "TEXT_BOX",
        width: 1,
        name: `rate_data.${index}.price`,
        element: { size: "small" },
      },
      {
        type: "TEXT_BOX",
        width: 1,
        name: `rate_data.${index}.extra_price`,
        element: {
          size: "small",
        },
      },
      {
        type: "TEXT_BOX",
        width: 1,
        name: `rate_data.${index}.min_units_type`,
        element: {
          size: "small",
        },
      },
      {
        type: "TEXT_BOX",
        width: 1,
        name: `rate_data.${index}.min_units_vehicle`,
        element: {
          size: "small",
        },
      },
      {
        type: "LABEL",
        width: 1,
        class_name: "has-text-centered p-2",
        name: `rate_data.${index}.addbuttons`,
        labelComponent: addRemoveButtons(index),
      },
    ];
  };

  return (
    <>
      <div className="column is-6 ">
        <span className="is-size-5 has-text-weight-bold">Rates:</span>
      </div>

      <div className="sd-hims-input sd-efl-input">
        <div className="columns is-gapless mb-0">
          <div className="column is-2 has-text-weight-bold">Type</div>
          <div className="column is-1 has-text-weight-bold">Vehicle Type</div>
          <div className="column is-2 has-text-weight-bold">Rate Type</div>
          <div className="column is-1 has-text-weight-bold">Range Start</div>
          <div className="column is-1 has-text-weight-bold">Range End</div>
          <div className="column is-1 has-text-weight-bold">Price(Rs)</div>
          <div className="column is-1 has-text-weight-bold">
            Extra Price(Rs)
          </div>
          <div className="column is-1 has-text-weight-bold">Min Unit</div>{" "}
          <div className="column is-1 has-text-weight-bold">Min Vehicle</div>
        </div>

        {fields.map((field, index) => (
          <SdsForm
            key={field.id}
            elements={getElements(index)}
            errors={errors}
            control={control}
            className="mb-1 is-gapless "
          />
        ))}
      </div>
    </>
  );
};

export default VendorRatesSubForm;
